import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { get, find, isEmpty } from 'lodash';

import { FilterValueType } from '../filter-types';
import metricTypeAttributes from './metric-type-attributes';
// import { extractMetricFilter } from '../../../utils/filters';

import './styles/MetricFilter.css';

const ONE_OPERAND_METRIC_PATTERN = '{metricType} {operator} {operand}';
const TWO_OPERAND_METRIC_PATTERN =
  '{metricType} {operand} {operator} {secondOperand}';
const TWO_OPERAND_METRIC_LABEL_PATTERN =
  '{metricType} {operator} {operand} & {secondOperand}';

class MetricFilter extends React.Component {
  /*
  static getDerivedStateFromProps({ value, options, operators }) {
    const newState =
      value === null
        ? {
            metricType: null,
            operand: '',
            operator: null,
            secondOperand: '',
            isOperatorBetween: false
          }
        : extractMetricFilter(get(value, 'value'), options, operators);

    return newState;
  }
  */

  state = {
    metricType: null,
    operand: '',
    operator: null,
    secondOperand: '',
    isOperatorBetween: false
  };

  onMetricChange = () => {
    const {
      isOperatorBetween,
      metricType,
      operand,
      operator,
      secondOperand
    } = this.state;

    if (isOperatorBetween && !secondOperand) {
      return;
    }

    if (!metricType || !operator || !operand) {
      return;
    }

    const valuePattern = isOperatorBetween
      ? TWO_OPERAND_METRIC_PATTERN
      : ONE_OPERAND_METRIC_PATTERN;

    const labelPattern = isOperatorBetween
      ? TWO_OPERAND_METRIC_LABEL_PATTERN
      : ONE_OPERAND_METRIC_PATTERN;

    const value = valuePattern
      .replace('{metricType}', metricType.value)
      .replace('{operand}', operand)
      .replace('{operator}', operator.value);

    const label = labelPattern
      .replace('{metricType}', metricType.label)
      .replace('{operand}', operand)
      .replace('{operator}', operator.label);

    if (isOperatorBetween) {
      this.props.onChange({
        value: value.replace('{secondOperand}', secondOperand),
        label: label.replace('{secondOperand}', secondOperand)
      });
    } else {
      this.props.onChange({ value, label });
    }
  };

  getMetricTypeGroup = metricTypeValue => {
    let group = find(metricTypeAttributes, groupType =>
      groupType.list.includes(metricTypeValue)
    );
    if (isEmpty(group)) {
      group = metricTypeAttributes.others;
    }
    return group;
  };

  updateMetricType = metricType => {
    const oldGroup = this.getMetricTypeGroup(
      isEmpty(this.state.metricType) ? {} : this.state.metricType.value
    );
    const newGroup = this.getMetricTypeGroup(
      isEmpty(metricType) ? {} : metricType.value
    );
    if (oldGroup.id === newGroup.id) {
      this.setState({ metricType }, this.onMetricChange);
    } else {
      const operand = newGroup.normalize(
        oldGroup.denormalize(this.state.operand)
      );
      const secondOperand = newGroup.normalize(
        oldGroup.denormalize(this.state.secondOperand)
      );

      this.setState(
        { metricType, operand, secondOperand },
        this.onMetricChange
      );
    }
  };

  updateOperator = operator =>
    this.setState(
      {
        operator,
        isOperatorBetween: get(operator, 'value') === 'to'
      },
      this.onMetricChange
    );

  updateOperand = ev => {
    const operand = get(ev, 'target.value', '');
    const { normalize } = this.getMetricTypeGroup(
      isEmpty(this.state.metricType) ? {} : this.state.metricType.value
    );
    const value = normalize(operand);
    this.setState({ operand: value }, this.onMetricChange);
  };

  updateSecondOperand = ev => {
    const secondOperand = get(ev, 'target.value', '');
    const { normalize } = this.getMetricTypeGroup(
      isEmpty(this.state.metricType) ? {} : this.state.metricType.value
    );
    const value = normalize(secondOperand);
    this.setState({ secondOperand: value }, this.onMetricChange);
  };

  render() {
    const {
      className,
      id,
      options,
      operators,
      classNamePrefix,
      components
    } = this.props;
    const { metricType } = this.state;
    const {
      placeholder1of1,
      placeholder1of2,
      placeholder2of2,
      denormalize
    } = this.getMetricTypeGroup(isEmpty(metricType) ? {} : metricType.value);

    return (
      <div className="tvt-filter__metric-wrapper">
        <Select
          id={`${id}-type`}
          classNamePrefix={classNamePrefix}
          className={className}
          components={components}
          onChange={this.updateMetricType}
          options={options}
          placeholder="Metric Type"
          defaultValue={this.state.metricType}
          isClearable
          isSearchable
        />

        <Select
          id={`${id}-operator`}
          classNamePrefix={classNamePrefix}
          className={className}
          components={components}
          onChange={this.updateOperator}
          options={operators}
          placeholder="Operator"
          defaultValue={this.state.operator}
          isClearable
          isSearchable
        />

        <input
          className={`${className} tvt-filter__metric-operand`}
          onChange={this.updateOperand}
          placeholder={
            this.state.isOperatorBetween ? placeholder1of2 : placeholder1of1
          }
          type="number"
          defaultValue={denormalize(this.state.operand)}
        />

        {this.state.isOperatorBetween && (
          <input
            className={`${className} tvt-filter__metric-operand`}
            onChange={this.updateSecondOperand}
            placeholder={placeholder2of2}
            type="number"
            defaultValue={denormalize(this.state.secondOperand)}
          />
        )}
      </div>
    );
  }
}

MetricFilter.propTypes = {
  classNamePrefix: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  components: PropTypes.shape({}).isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: FilterValueType, // eslint-disable-line react/no-unused-prop-types,
  options: PropTypes.array, // eslint-disable-line
  operators: PropTypes.array // eslint-disable-line
};

MetricFilter.defaultProps = {
  value: null,
  options: [],
  operators: []
};

export default MetricFilter;
